export const DashboardData = `
  id
  name
  url
  reportLink
  groupId
  reportId
  isActive
  useDynamicParams
  dynamicParams {
    name
    value
  }
  createdAt
  lastModifiedAt
  roles {
    id
    name
  }
`;
